import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { price_format } from "../../../helpers/helpers";
import { isPublicPlan } from "../../../helpers/pricingPlans.mjs";
import Text from "../../common/Text";
import FormProcessingSpinner from "../../common/FormProcessingSpinner";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomPopup from "../../../states/actions/CancelPopup";
import "../../../../src/CSS/App.css";
import PricingCard from "../../new_redesign_components/ui/card/PricingCard";
import styles from "../../../CSS/sections/Pricing.module.css";
import PricingContent from "../../new_redesign_components/content/Pricing.json";

const Packages = ({
  handleCancelSubscription,
  isFormProcessing,
  handleUpdateSubscription,
}) => {
  const authToken = useSelector((state) => state.fetchSignin.authToken);
  const [currentTab, setCurrentTab] = useState(1);
  const [show, setShow] = useState(false);
  const data = useSelector((state) => state.fetchPricing.content);
  const { content, monthly_plans, annual_plans } = data;
  const site_settings = useSelector(
    (state) => state.fetchSiteSettings.site_settings
  );
  const subscription = site_settings?.member?.mem_subscription;
  const user_subscription_exist =
    site_settings?.member?.user_subscription_exist;
  const handleTabClick = (tab) => {
    setCurrentTab(tab);
  };

  const handleToggle = () => {
    setShow(!show);
  };
  
  // console.log(data)
   const { pricing, faq } = PricingContent;
   const { title, description, addons, addOnPrice } = pricing;

   const features = [
      "<b>Verified Owner Contact Information</b></br>Connect with property owners using accurate names, phone numbers, and emails for more personal and effective outreach.",
      "<b>Quarterly Updated Property Intelligence</b></br>Access property data refreshed four times a year so you can plan and reach out with confidence.",
      "<b>Powerful Filtering That Finds the Right Prospects</b></br>Use 210,000+ filter combinations to quickly target the properties and owners that matter most.",
      "<b>Saved Searches That Keep You Moving</b></br>Save searches and return anytime so you can spend less time setting up and more time taking action.",
    ]

   const weatherFeature = "<b>Three Years of Property-Specific Weather History*</b><br>Access three years of updated weather data, including hail size, wind intensity, and time stamped storms perfect for inspections, claims, and timely outreach."

   // Legend-only from 2026-09-22. These are gated server-side for new Lite/Pro
   // subscriptions (PlanEntitlements: commercial_properties, investor_portfolio),
   // so the page has to say so rather than let someone buy Lite expecting them.
   const legendOnlyFeature = "<b>Commercial Properties &amp; Investor Portfolio*</b><br>Search commercial property categories &mdash; office, retail, industrial, medical and more.<br>Target owners by portfolio size to find who holds multiple properties."
   

  return (
    <>
        <section className={`${styles.testimonialsSection} padding-y`}>
          <div className="container">
            <h1 className="heading1 mb-2 text-center">{title}</h1>
            <p className="p18 font-medium text-center" style={{marginBottom: 80}}>{description}</p>
            {/* <div className={`d-flex justify-content-center ${styles.billingBtn}`}>
              <button className={`btn ${styles.active}`}>Billed Monthly</button>
              <button className="site_btn blank">Yearly</button>
            </div> */}
           <div className={styles.pricingLayout}>
  <div className={`${styles.leftCol} d-flex flex-column gap-4`}>
    {/* Which plans are listed (and why): see isPublicPlan(). */}
    {monthly_plans &&
      monthly_plans
        .filter(isPublicPlan)
        .map((plan) => {
          // Transform the plan data to match PricingCard structure
          const cardContent = {
            id: plan.plan_slug,
            name: plan.plan_name,
            price:
              parseInt(plan.is_enterprise) === 1
                ? null
                : parseInt(plan.price),

            billingCycle:
              parseInt(plan.is_enterprise) === 1
                ? null
                : "mo",

            credits:
              parseInt(plan.is_enterprise) === 1
                ? "Custom"
                : plan.clicks_count,

            users:
              parseInt(plan.is_enterprise) === 1
                ? "Custom"
                : plan.user_count,

            annualPlan:
              parseInt(plan.is_enterprise) === 1
                ? "Annual package available"
                : "",

            creditsNote:
              parseInt(plan.is_enterprise) !== 1
                ? "Credits unlock contacts, 1 credit per property"
                : "",

            cta: {
              label: plan.button_text.trim(),
              url:
                parseInt(plan.is_enterprise) === 1
                  ? `/enterprise-checkout/${plan.encoded_id}/${plan.plan_slug}`
                  : authToken
                  ? `/checkout/${plan.encoded_id}`
                  : "/signup",
            },

            highlight:
              plan.best_status === 1 ? true : "",

            description:
              parseInt(plan.is_enterprise) === 1
                ? "For more information"
                : "",
          };

          return (
            <PricingCard
              key={plan.id}
              content={cardContent}
            />
          );
        })}
  </div>

  <div className={`${styles.rightCol}`}>
    <div className={styles.featureCard}>
      <h4
        className="heading4 text-black font-bold"
        style={{ marginBottom: 42 }}
      >
        Each Plan Features
      </h4>

      <ul
        className={`${styles.listFeatures} d-flex flex-column gap-3`}
      >
        {features.map((feature, index) => (
          <li
            key={index}
            className="text-dark"
            dangerouslySetInnerHTML={{
              __html: feature,
            }}
          />
        ))}
      </ul>

      <hr />

      <ul
        className={`${styles.listFeatures} d-flex flex-column gap-3`}
      >
        <li
          className="text-dark"
          dangerouslySetInnerHTML={{
            __html: weatherFeature,
          }}
        />
      </ul>

      <p
        className="p12 text-gray mb-0"
        style={{ marginTop: 8 }}
      >
        * Only available on Rhino Pro and Legend Plans
      </p>

      <hr />

      <ul
        className={`${styles.listFeatures} d-flex flex-column gap-3`}
      >
        <li
          className="text-dark"
          dangerouslySetInnerHTML={{
            __html: legendOnlyFeature,
          }}
        />
      </ul>

      <p className={`p12 text-gray ${styles.legendNote}`}>
        <span>
          * Only available on the Rhino Legend plan.
        </span>
      </p>
    </div>
  </div>
</div>
          </div>
        </section>

        {show ? (
          <>
            <div>
              <CustomPopup onCancel={handleToggle} />
            </div>
          </>
        ) : null}
    </>
  );
};

export default Packages;
